import { HttpParams } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AuthOptions, OidcSecurityService } from 'angular-auth-oidc-client';
import jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { ApiService } from '@app/services/api.service';
import { AppRoutes } from '@shared/constants/app-routes.const';
import { AuthService } from '@shared/services/auth.service';

@UntilDestroy()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent extends ComponentAbstract implements OnInit {
  constructor(
    protected cdr: ChangeDetectorRef,
    public oidcSecurityService: OidcSecurityService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    super(cdr);
  }

  ngOnInit() {
    this.wakeApp().subscribe().untilDestroyed(this);
  }

  private wakeApp(): Observable<any> {
    return this.apiService.getData<any>('Wake').pipe(
      tap(() => {
        const returnUrl =
          this.route.snapshot.queryParams.returnUrl?.replace(window.location.origin, '') || AppRoutes.HOME;

        let idTokenHint: string;
        if (returnUrl?.includes('?')) {
          const httpParams = new HttpParams({ fromString: returnUrl.split('?')[1] });
          idTokenHint = httpParams.get('id_token_hint');
        }

        const authOptions = { customParams: {} } as AuthOptions;
        let authConfigId = idTokenHint ? 'email' : 'main';

        if (idTokenHint) {
          const jwtInfo: IdTokenJwtInfo = jwt_decode(idTokenHint);

          if (jwtInfo.objectId) {
            authConfigId = 'objectId';
          }

          authOptions.customParams['id_token_hint'] = idTokenHint;
        }

        this.authService.setConfigId(authConfigId);
        if (returnUrl) {
          localStorage.setItem('returnUrl', returnUrl);
        } else {
          localStorage.removeItem('returnUrl');
        }

        this.oidcSecurityService.authorize(authConfigId, authOptions);
      })
    );
  }
}

export class IdTokenJwtInfo {
  nbf: number;
  exp: number;
  iat: number;
  iss: string;
  oid: string;
  objectId: string;
}
